// This component's only purpose is to reduce props passing
import React, { createContext, useContext } from 'react';

const InfraContext = createContext({});

export const InfraProvider = ({ children, t, trackEvent, trackError, tAbs, ...rest }) => <InfraContext.Provider value={{ t, trackEvent, trackError, tAbs, ...rest }}>{children}</InfraContext.Provider>;
export const useInfra = () => useContext(InfraContext);
